import { getMainTabs } from './getMainTabs';

export const mainService = {
  getMainTabs,
};
